import { Component, inject, input } from '@angular/core';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmIconImports } from '@spartan-ng/helm/icon';

import { RouterModule } from '@angular/router';
import { Cartographie } from '../../../../cartographie/models/cartographie.model';
import { ChipComponent } from '../../../../shared/components/chip/chip.component';
import { SidepanelService } from '../../../../shared/components/sidepanel/sidepanel.service';
import { Production } from '../../../référentiel-métier-processus/processus-aptitude/models/production.model';
import { RessourcesProfessionnellesFormComponent } from '../ressources-professionnelles-form/ressources-professionnelles-form.component';

@Component({
  selector: 'app-production-item',
  imports: [HlmButtonImports, HlmIconImports, ChipComponent, RouterModule],
  templateUrl: './production-item.component.html',
})
export class ProductionItemComponent {
  readonly #sidepanelService = inject(SidepanelService);

  readonly cartographie = input.required<Cartographie>();
  readonly production = input.required<Production>();
  readonly idAptitude = input.required<string>();
  readonly peutModifier = input.required<boolean>();

  ajouterRessource() {
    this.#sidepanelService.setComponentToDisplay(
      'Ajouter une nouvelle ressource professionnelle',
      RessourcesProfessionnellesFormComponent,
      `Renseignez les ressources professionnelles rattachées à la production <span class="font-semibold">${this.production().nom}</span>.`,
      { cartographie: this.cartographie(), idProduction: this.production().id },
    );
    this.#sidepanelService.open();
  }
}
